import React from 'react';
import { Button } from '@material-ui/core';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import { useParams } from 'react-router-dom';
import { useToast } from '../../ToastProvider/ToastProvider';

export default function LocalPrintButton() {
  const params = useParams<{ URLModulo?: string; URLRoomName?: string }>();
  const { showToast } = useToast();

  const handleClick = async () => {
    const { URLModulo, URLRoomName } = params;

    if (!URLModulo || !URLRoomName) {
      alert('[LocalPrintButton] Parâmetros ausentes');
      return;
    }

    // 🔍 Pega o PRIMEIRO vídeo renderizado (remoto)
    const video = document.querySelector('video') as HTMLVideoElement | null;

    if (!video) {
      alert('[LocalPrintButton] Vídeo remoto não encontrado');
      return;
    }

    if (video.videoWidth === 0 || video.videoHeight === 0) {
      alert('[LocalPrintButton] Vídeo ainda não carregado');
      return;
    }

    try {
      const scale = 2;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth * scale;
      canvas.height = video.videoHeight * scale;

      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas sem contexto');

      // 📸 PRINT DO VÍDEO REMOTO
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const base64 = canvas.toDataURL('image/png');
      const base64Short = base64.substring(base64.indexOf(',') + 1);
      const fileName = `Foto_${URLModulo}.png`;

      const image = {
        conteudo: base64Short,
        arquivo: fileName,
        categoria: 'categoria',
      };

      let modulo = '';
      switch (URLModulo) {
        case 'telereg':
          modulo = 'regulacao';
          break;
        case 'teleinsp':
          modulo = 'inspecao';
          break;
        default:
          throw new Error(`Módulo inválido: ${URLModulo}`);
      }

      const response = await fetch(
        `https://cosmos.ativapericias.com.br/auto/${modulo}/tele/${URLRoomName}/enviar-fotos`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(image),
        }
      );

      if (!response.ok) throw new Error('Erro ao enviar imagem');

      await response.json();

      showToast('Foto local tirada e enviada com sucesso!', 'success');
    } catch (err) {
      console.error('[LocalPrintButton] Erro:', err);
      showToast('Erro ao tirar ou enviar a foto local', 'error');
    }
  };

  return (
    <Button onClick={handleClick} startIcon={<PhotoCameraIcon style={{ color: '#707578' }} />}>
      Tirar foto local
    </Button>
  );
}
